import * as React from "react";
import * as ReactDOM from "react-dom";
import { AlertType } from "./";

type ChildrenFunc = (dataSource: any) => JSX.Element | JSX.Element[];

interface IProperties
{
    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Child Elemente.
     */
    children: JSX.Element | JSX.Element[] | string,

    /**
     * Der Typ des Alerts.
     */
    alertType?: AlertType,

    /**
     * Gibt an ob das Alert sichtbar ist.
     */
    isVisible?: boolean,

    /**
     * Gibt an ob das Alert geschlossen werden kann.
     */
    isClosable?: boolean,

    /**
     * Wird ausgeführt, sobald auf den Button zum schließen des Alerts geklickt wird.
     */
    onHide?: () => void
}

export class Alert extends React.Component<IProperties>
{
    /**
     * Standardwerte der Eigenschaften.
     */
    public static defaultProps: Partial<IProperties> = {
        alertType: AlertType.info,
        isVisible: false
    };

    /**
     * Führt die "onHide" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onHide = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onHide && this.props.onHide();
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { style, children, alertType, isVisible, isClosable } = this.props;

        if (!isVisible)
            return null;

        return (
            <div
                style={style}
                className={"alert " + alertType}>
                {isClosable && (
                    <i
                        className="alert_close-btn mdi mdi-close mdi-18px"
                        title="Benachrichtigung schließen"
                        onClick={this.onHide}></i>
                )}
                {children}
            </div>
        );
    }
}